import React, { useEffect, useRef, useState } from "react"
//import { useTranslation } from "react-i18next"
import { IoMdMenu } from "react-icons/io"
import * as styles from "./MainNav.module.scss"
import NavLinks, { NavLinkNode } from "./NavLinks"

type MainNavProps = {
  menuTree: NavLinkNode[]
  labelOpen: string
  labelClose: string
}

const MainNav = (props: MainNavProps) => {
  // console.debug("Rendering MainNav", props)

  const navRef = useRef<HTMLElement>(null)
  const [isOpen, setOpen] = useState(false)

  useEffect(() => {
    function mainNavOutsideCloseHandler(e: MouseEvent): void {
      // suljetaan navi jos klikattu sen ulkpouolelle
      if (navRef.current && !navRef.current.contains(e.target as HTMLElement)) {
        setOpen(false)
      }
    }

    document.addEventListener("click", mainNavOutsideCloseHandler)
    return (): void => {
      document.removeEventListener("click", mainNavOutsideCloseHandler)
    }
  }, [navRef])

  if (!props.menuTree) {
    return null
  }

  const clickHandler = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault()
    setOpen(!isOpen)
  }

  return (
    <nav className={`${styles.container} ${isOpen ? styles.open : styles.closed}`} ref={navRef}>
      <button
        onClick={clickHandler}
        className={styles.menuToggle}
        aria-expanded={isOpen}
        aria-controls="mainmenu"
        aria-haspopup={true}
        aria-label={isOpen ? props.labelClose : props.labelOpen}>
        <IoMdMenu />
      </button>
      <ul id="mainmenu" className={`${styles.list}`}>
        <NavLinks nodes={props.menuTree} level={1} />
      </ul>
    </nav>
  )
}

export default MainNav
